import React from 'react';
import { FilterDataStructure, FilterState,filter } from './Products';

// Define the props interface, if your component accepts props
interface SidebarProps {
  // Define your prop types here
  filterData: FilterDataStructure;
  selectedFilters: number[];
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

// Functional component
const SideBarFilterCheckbox: React.FC<SidebarProps> = ({ filterData,selectedFilters,handleChange }) => {
  // You can add your component logic here

  return (
    <>
    {filterData.filters.map((Val) => {
        return (
        <li className="checkbox" key={Val.id}>
            <input type="checkbox"
             id={`${Val.id}`}
              name={filterData.section_key}
               value={Val.id} 
               title={Val.name}
                className="filter-on-change"
                 onChange={handleChange}
                 checked={selectedFilters.includes(Val.id)} 
                 ></input>

            <label className="checkmark" htmlFor={`${Val.id}`}>
                <span className={Val.icon !== (null) ? Val.icon : "circle"}></span>
                <span className="name">{Val.name}</span>
            </label>
        </li>
        );
    })}
</>
  );
};




/*

const SidebarFilterCheckbox = ({ fDataItem: any, handleChange}) => {
    // destructuring props

    return (
        <>
            {fDataItem.filters.map((Val: any) => {
                return (
                <li className="checkbox" key={Val.id}>
                    <input type="checkbox" id={`check-${Val.id}`} name={fDataItem.section_key} value={Val.id} title={Val.name} className="filter-on-change" onChange={handleChange}></input>
                    <label className="checkmark" htmlFor={`check-${Val.id}`}>
                        <span className={Val.icon !== null ? Val.icon : "circle"}></span>
                        <span className="name">{Val.name}</span>
                    </label>
                </li>
                );
            })}
        </>
    );
};
*/
export default SideBarFilterCheckbox;

